<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-alert
      title="Bugün İşlem Yapmadınız"
      type="success"
      :closable="false"
      v-if="!data">
    </el-alert>
    <el-table
      class="table-xs"
      style="width: 100%"
      width="100%"
      :data="Liste"
      v-if="data"
      row-key="id"
      :height="Height">
      <el-table-column
        prop="Saat"
        label="Saat"
        width="50">
      </el-table-column>
      <el-table-column
        prop="Aciklama"
        label="Açıklama">
      </el-table-column>

    </el-table>
  </div>

</template>

<script>
  import Yukleniyor from "../../Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    data() {
      return {
        lo: true,
        Liste: null,
        data: null,
        Height: window.innerHeight - 370
      }
    },
    methods: {
      SayfaYukle() {
        this.$store.dispatch("Get", {path: 'panel/log'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste;
              this.lo = false;
              if (this.Liste) this.data = true;
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      },
    },
    created() {
      this.SayfaYukle();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Panel/PanelSonIslemler.vue